// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1_qB7","topBottomGutter":"Layout_topBottomGutter__CMnOu"};